import React from "react";
import FontSizeStepper from "./SettingsCompoments/fontSizeStepper";
import ColorPicker from "./SettingsCompoments/colorPicker";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class ChatPageSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSize: props.fontSize,
      toggleAutoScroll: props.toggleAutoScroll,
      onFontChange: (e) => { props.onFontChange(e) },
      onUserChatBgColorChange: (e) => props.onUserChatBgColorChange(e),
      onAssistantChatBgColorChange: (e) => props.onAssistantChatBgColorChange(e),
      onToggleAutoScrollChange: (e) => props.onToggleAutoScrollChange(e)
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.fontSize !== this.props.fontSize) {
      this.setState({ fontSize: this.props.fontSize })
    }
    if (prevProps.toggleAutoScroll !== this.props.toggleAutoScroll) {
      this.setState({ toggleAutoScroll: this.props.toggleAutoScroll })
    }
  }

  render() {
    return (
      <React.Fragment>
        <h3 style={{ textAlign: 'center' }}>Settings</h3>
        <h4>Font Size</h4>
        <FontSizeStepper onChange={(n) => {
          this.setState(e => e.fontSize += n)
          this.state.onFontChange(this.state.fontSize + n)
        }} />
        <h4>User Chat Background</h4>
        <ColorPicker onChange={(e) => {
          this.state.onUserChatBgColorChange(e)
        }} />
        <h4>Assistant Chat Background</h4>
        <ColorPicker onChange={(e) => {
          this.state.onAssistantChatBgColorChange(e)
        }} />
        <h4>Toggle Chat Auto Scroll</h4>
        <FormControlLabel
          style={{marginLeft:20, marginTop: -10}}
          control={
            <Checkbox
              checked={this.state.toggleAutoScroll}
              onChange={() => { this.state.onToggleAutoScrollChange() }}
              value={this.state.toggleAutoScroll}
            />
          }
          label={this.state.toggleAutoScroll ? "Enabled" : "Disabled"}
        />
      </React.Fragment>
    );
  }
}

export default ChatPageSettings;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/sidebar/ChatPageSettings/chatPageSettings.jsx